var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-box-grid"},[_c('div',{class:{
      'left-icon-position': !_vm.isRightSide,
      'right-icon-position': _vm.isRightSide,
    }},[_c('svg',{staticClass:"default-icon icon-display",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"href":"#icon-icon"}})])]),_c('img',{staticClass:"image-position",attrs:{"src":_vm.imgURL,"alt":"image!!!"}})])}
var staticRenderFns = []

export { render, staticRenderFns }